.summaryContent {
	@apply yst-flex yst-gap-4 yst-items-center yst-flex-1 yst-min-w-0;
}

.logo {
	@apply yst-w-10 yst-h-10 yst-rounded-lg yst-object-contain yst-bg-slate-50 yst-flex-shrink-0;
}

.logoPlaceholder {
	@apply yst-w-10 yst-h-10 yst-rounded-lg yst-flex yst-items-center yst-justify-center;
	@apply yst-text-white yst-font-bold yst-text-base yst-flex-shrink-0 yst-bg-primary-500;
}

.appInfo {
	@apply yst-flex-1 yst-min-w-0 yst-flex yst-justify-between yst-items-center yst-gap-4;
}

.appDetails {
	@apply yst-min-w-0;

	h3 {
		@apply yst-truncate;
	}
}

.clientLink {
	@apply yst-text-xs;
}

.hostnames {
	@apply yst-text-xs yst-text-slate-600;
}

.lastUsed {
	@apply yst-text-xs yst-text-slate-500 yst-whitespace-nowrap yst-flex-shrink-0;
}

.expandedContent {
	@apply yst-space-y-4;
}

.permissions {
	@apply yst-space-y-2;
}

.permissionsLabel {
	@apply yst-text-sm yst-font-medium yst-text-slate-700 yst-mb-2;
}

.permissionsList {
	@apply yst-space-y-2 yst-list-none yst-p-0 yst-m-0;

	li {
		@apply yst-flex yst-items-start yst-gap-2;
	}
}

.scopeIcon {
	@apply yst-w-4 yst-h-4 yst-text-primary-500 yst-flex-shrink-0 yst-mt-0.5;
}

.scopeText {
	@apply yst-flex yst-flex-col yst-gap-0.5;
}

.scopeTitle {
	@apply yst-text-slate-700 yst-text-sm yst-font-medium;
}

.scopeDescription {
	@apply yst-text-slate-500 yst-text-xs;
}

.providedBy {
	@apply yst-text-xs yst-text-slate-500;
}

.footer {
	@apply yst-flex yst-justify-end yst-pt-4 yst-border-t yst-border-slate-300;
	border-top-width: 1px !important;
}
